// Mirrors XpressAppTypeEnum on the backend. Not the same numbering as XpressClientTypeEnum.
export enum XpressAppTypeEnum {
    EveryDayApp = 1,
    DriverApp = 2,
    BYDTaxiApp = 3
}
